import React, { Component, useState, useEffect } from "react";
import { FormControl, InputGroup, Tab, Tabs, Button, Container, ListGroup, Row, Col, Image} from "react-bootstrap";
import "./searchUser.scss";
import User from "../../common/user/user";
import ApiV2 from "../../common/apiV2";
import defaultPhoto from "../../images/default.png";
import PropTypes from "prop-types";
import { Link, withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock } from "@fortawesome/free-solid-svg-icons";

function SearchUserPage(props) {
    const [users, setUsers] = useState([])
    const [search, setSearch] = useState("")

    useEffect(() => {
        if (search !== ""){
            fetchUsers();
        } else {
            setUsers([]);
        }

    },[search]);

    //function to search users using the backend api call
    const fetchUsers = async () => {
        const response = await ApiV2.searchUser(search)
        setUsers(response.sort((a,b) => a.firstName.localeCompare(b.firstName)));
    }

    const followUser = async (userId) => {
        try {
            const response = await ApiV2.followUser(userId);
            props.notifyInfo("Followed user");
        } catch (error) {
            props.notifyFailure("Couldn't follow user: ", JSON.stringify(error));
        }
    }

    const getProfilePhoto = (user) =>  {
        if (user.photoURL) {
            return (user.photoURL);
        } else {
            return (defaultPhoto);
        }
        return defaultPhoto;
    }

    // const getFollowButton = async (userId) => {
    //     console.log("HEY");
    //     try {
    //         console.log("HEY2");
    //         const {data} = await ApiV2.getIsFollowing(userId);
    //         console.log("DATA", JSON.stringify(data));
    //         console.log("HEY3");
    //         // if (data.isFollowing){
    //         //     return(
    //         //         <Button>Following</Button>
    //         //     )
    //         // } else {
    //         //     return(
    //         //         <Button>Follow</Button>
    //         //     )
    //         // }
    //         // props.notifyInfo("Followed user");
    //     } catch (error) {
    //         // return(
    //         //     <></>
    //         // );
    //         // props.notifyFailure("Couldn't follow user: ", JSON.stringify(error));
    //     }
    // }

    const renderAccountSearch = () => {
        if (users){
            if (Array.isArray(users)) {
                const results = users.map(user => {
                    return (
                        <User user={user}/>
                    );
                });
                return results;
            }
        }
    }

    //render results here
    return (
        <Container className ="search-user-page child-container p-0">
            <InputGroup className="mt-3 mb-0 px-3" >
                <FormControl
                    placeholder="Search"
                    aria-label="Search"
                    aria-describedby="basic-addon2"
                    onChange={event => {
                        setSearch(event.target.value)
                    }}
                />
                <InputGroup.Append>
                    <Button 
                    variant="outline-secondary"
                    >Clear</Button>
                </InputGroup.Append>
            </InputGroup>

            <Tabs variant="pills" className="search-tab full-width justify-content-between">
                <Tab eventKey="Accounts" title="Accounts">{renderAccountSearch()}</Tab>
                <Tab eventKey="Top" title="Top"></Tab>
                <Tab eventKey="Tags" title="Tags" ></Tab>
                <Tab eventKey="Places" title="Places"></Tab>
            </Tabs>
        </Container>
    );
}

export default withRouter(SearchUserPage);

SearchUserPage.propTypes = {
    notifyInfo: PropTypes.func.isRequired,
    notifyFailure: PropTypes.func.isRequired
};
